import {ungzipToString} from './ungzipToString'

// Декодирует строку из base64 и разжимает ее с помощью gzip.
export async function ungzipBase64EncodedString(str: string): Promise<string> {
    const bin = atob(str)
    const byteArray = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i++) {
        byteArray[i] = bin.charCodeAt(i)
    }

    return ungzipToString(byteArray)
}
